import { CycleUtils } from '@wix/package-picker-shared';
import { fetchMoneyFormatterQueryFn } from './fetch-money-formatter.query';
import { fetchProductQueryFn } from './fetch-product.query';
export const fetchProductPricingQueryFn = async props => {
  const {
    httpClient,
    request: {
      productId
    }
  } = props;
  const [productData, formatMoneyData] = await Promise.all([fetchProductQueryFn({
    httpClient,
    request: {
      productId
    }
  }), fetchMoneyFormatterQueryFn({
    httpClient,
    request: {}
  })]);
  const {
    pricingDetails
  } = productData;
  const {
    formatMoney
  } = formatMoneyData;
  const cyclePricingItems = (pricingDetails ?? []).map(pricingDetailsItem => {
    var _finalPrice$discount;
    const {
      cycle,
      savings,
      initialPurchasePrice,
      finalPrice
    } = pricingDetailsItem;
    if (!cycle) {
      throw Error(`No cycle in pricingDetailsItem ${productId}`);
    }
    return {
      cycle,
      cycleId: CycleUtils.convertCycleToCycleId(cycle),
      monthlyFullPrice: initialPurchasePrice == null ? void 0 : initialPurchasePrice.monthlyTotal,
      monthlyFinalPrice: finalPrice == null ? void 0 : finalPrice.monthlyTotal,
      discountFixedAmount: formatMoney(finalPrice == null || (_finalPrice$discount = finalPrice.discount) == null ? void 0 : _finalPrice$discount.fixedAmount),
      savings: {
        ...savings,
        fixedAmount: formatMoney(savings == null ? void 0 : savings.fixedAmount),
        percent: formatMoney(savings == null ? void 0 : savings.percent)
      }
    };
  });
  return {
    cyclePricingItems
  };
};
//# sourceMappingURL=fetch-product-pricing.query.js.map